import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.boltin.com';
const PO_API_PATH = '/api/purchase-orders';

const fetchPurchaseOrders = async (params = {}) => {
  const response = await axios.get(`${API_BASE_URL}${PO_API_PATH}`, { params });
  return response.data;
};

const getPurchaseOrder = async (id) => {
  const response = await axios.get(`${API_BASE_URL}${PO_API_PATH}/${id}`);
  return response.data.data;
};

const createPurchaseOrder = async (payload) => {
  const response = await axios.post(`${API_BASE_URL}${PO_API_PATH}`, payload);
  return response.data.data;
};

const updatePurchaseOrder = async (id, payload) => {
  const response = await axios.put(`${API_BASE_URL}${PO_API_PATH}/${id}`, payload);
  return response.data.data;
};

const deletePurchaseOrder = async (id) => {
  await axios.delete(`${API_BASE_URL}${PO_API_PATH}/${id}`);
};

const updatePurchaseOrderStatus = async (id, status) => {
  const response = await axios.put(`${API_BASE_URL}${PO_API_PATH}/${id}/status`, { status });
  return response.data.data;
};

const createPurchaseReceipt = async (id, payload) => {
  const response = await axios.post(`${API_BASE_URL}${PO_API_PATH}/${id}/receipts`, payload);
  return response.data.data;
};

const fetchPurchaseReceipts = async (id) => {
  const response = await axios.get(`${API_BASE_URL}${PO_API_PATH}/${id}/receipts`);
  return response.data.data;
};

const purchaseOrderService = {
  fetchPurchaseOrders,
  getPurchaseOrder,
  createPurchaseOrder,
  updatePurchaseOrder,
  deletePurchaseOrder,
  updatePurchaseOrderStatus,
  createPurchaseReceipt,
  fetchPurchaseReceipts,
};

export default purchaseOrderService;
